<div class="modal-overlay" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <div class="user-avatar-large">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </div>
        <div class="header-info">
          <h2>{{ userName }}</h2>
          <p>{{ userRole }}</p>
        </div>
      </div>
      <button class="btn-close" (click)="onClose()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Tab Navigation -->
    <div class="tab-navigation">
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'profile'"
        (click)="switchTab('profile')">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        ข้อมูลส่วนตัว
      </button>
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'password'"
        (click)="switchTab('password')">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
        เปลี่ยนรหัสผ่าน
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <!-- Profile Tab -->
      <div *ngIf="activeTab === 'profile'" class="profile-tab">
        <!-- Personal Information Section -->
        <div class="info-section">
          <div class="section-header">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <h3>ข้อมูลส่วนตัว</h3>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <label>ชื่อ-นามสกุล</label>
              <span>{{ userName }}</span>
            </div>
            <div class="info-item">
              <label>เลขบัตรประชาชน</label>
              <span>{{ userDetails?.cid || '-' }}</span>
            </div>
            <div class="info-item">
              <label>อีเมล</label>
              <span>{{ userEmail }}</span>
            </div>
            <div class="info-item">
              <label>เบอร์โทรศัพท์</label>
              <span>{{ userPhone }}</span>
            </div>
          </div>
        </div>

        <!-- Organization Information Section -->
        <div class="info-section">
          <div class="section-header">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            <h3>ข้อมูลองค์กร</h3>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <label>องค์กร</label>
              <span>{{ userOrganization }}</span>
            </div>
            <div class="info-item">
              <label>ตำแหน่ง</label>
              <span>{{ userRole }}</span>
            </div>
            <div class="info-item">
              <label>ระดับ</label>
              <span>{{ userRank }}</span>
            </div>
          </div>
        </div>

        <!-- License Information Section -->
        <div class="info-section">
          <div class="section-header">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14,2 14,8 20,8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
            </svg>
            <h3>ข้อมูลใบอนุญาต</h3>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <label>VAT ID</label>
              <span>{{ vatId }}</span>
            </div>
            <div class="info-item">
              <label>VAT หมดอายุ</label>
              <span>{{ vatExpiryText }}</span>
            </div>
            <div class="info-item">
              <label>Valuer ID</label>
              <span>{{ valuerId }}</span>
            </div>
            <div class="info-item">
              <label>Valuer หมดอายุ</label>
              <span>{{ formatDate(userDetails?.userInformation?.valuerExpired) }}</span>
            </div>
          </div>
        </div>

        <!-- Address Information Section -->
        <div class="info-section">
          <div class="section-header">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            <h3>ที่อยู่</h3>
          </div>
          <div class="info-grid">
            <div class="info-item full-width">
              <label>ที่อยู่ปัจจุบัน</label>
              <span>{{ currentAddress }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Password Tab -->
      <div *ngIf="activeTab === 'password'" class="password-tab">
        <!-- Success Message -->
        <div *ngIf="successMessage" class="alert alert-success">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          {{ successMessage }}
        </div>

        <!-- Error Message -->
        <div *ngIf="errorMessage" class="alert alert-error">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
          {{ errorMessage }}
        </div>

        <form [formGroup]="passwordForm" (ngSubmit)="onChangePassword()">
          <div class="form-group">
            <label for="currentPassword">รหัสผ่านปัจจุบัน</label>
            <div class="input-wrapper">
              <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              <input 
                type="password" 
                id="currentPassword"
                formControlName="currentPassword"
                placeholder="กรอกรหัสผ่านปัจจุบัน"
                [class.error]="passwordForm.get('currentPassword')?.invalid && passwordForm.get('currentPassword')?.touched">
            </div>
            <span class="error-message" *ngIf="passwordForm.get('currentPassword')?.invalid && passwordForm.get('currentPassword')?.touched">
              <span *ngIf="passwordForm.get('currentPassword')?.errors?.['required']">กรุณากรอกรหัสผ่านปัจจุบัน</span>
              <span *ngIf="passwordForm.get('currentPassword')?.errors?.['minlength']">รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร</span>
            </span>
          </div>

          <div class="form-group">
            <label for="newPassword">รหัสผ่านใหม่</label>
            <div class="input-wrapper">
              <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              <input 
                type="password" 
                id="newPassword"
                formControlName="newPassword"
                placeholder="กรอกรหัสผ่านใหม่"
                [class.error]="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched">
            </div>
            <span class="error-message" *ngIf="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched">
              <span *ngIf="passwordForm.get('newPassword')?.errors?.['required']">กรุณากรอกรหัสผ่านใหม่</span>
              <span *ngIf="passwordForm.get('newPassword')?.errors?.['minlength']">รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร</span>
            </span>
          </div>

          <div class="form-group">
            <label for="confirmPassword">ยืนยันรหัสผ่านใหม่</label>
            <div class="input-wrapper">
              <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              <input 
                type="password" 
                id="confirmPassword"
                formControlName="confirmPassword"
                placeholder="กรอกรหัสผ่านใหม่อีกครั้ง"
                [class.error]="passwordForm.get('confirmPassword')?.invalid && passwordForm.get('confirmPassword')?.touched">
            </div>
            <span class="error-message" *ngIf="passwordForm.get('confirmPassword')?.invalid && passwordForm.get('confirmPassword')?.touched">
              <span *ngIf="passwordForm.get('confirmPassword')?.errors?.['required']">กรุณายืนยันรหัสผ่านใหม่</span>
              <span *ngIf="passwordForm.get('confirmPassword')?.errors?.['passwordMismatch']">รหัสผ่านไม่ตรงกัน</span>
            </span>
          </div>

          <div class="form-actions">
            <button type="button" class="btn-secondary" (click)="passwordForm.reset()">
              ล้างข้อมูล
            </button>
            <button type="submit" class="btn-primary" [disabled]="isSubmitting">
              <svg *ngIf="isSubmitting" class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83"></path>
              </svg>
              <span *ngIf="!isSubmitting">บันทึกรหัสผ่าน</span>
              <span *ngIf="isSubmitting">กำลังบันทึก...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
